const aciersSpeciaux = [
  {
    id: "fer-rond-42cd4",
    title: "Fer rond Acier 42 CD4",
    image: "/assets/images/products/Fer rond Acier 42 CD4.webp",
    specImage: null,
    description: "Acier de traitement thermique pour pièces mécaniques résistantes",
    longDescription: "SAN METAL BY BEN AMOR, vous propose une large gamme de Fer rond acier 42 CD4.",
    category: "aciers_speciaux",
    specifications: [
      "Aucune spécification technique fournie",
      "Pièces mécaniques soumises à des contraintes élevées",
      "Excellent rapport qualité/prix",
      "Disponible en diverses dimensions",
      "Livraison rapide"
    ]
  },
  {
    id: "fer-rond-acier-xc48",
    title: "Fer rond Acier XC48",
    image: "/assets/images/products/Fer rond Acier XC48.jpg",
    specImage: null,
    description: "Acier mi-dur pour pièces mécaniques courantes",
    longDescription: "(Pas de description visible)",
    category: "aciers_speciaux",
    specifications: [
      "Aucune spécification technique fournie",
      "Bon équilibre entre résistance mécanique et usinabilité",
      "Traitement thermique possible",
      "Pour pièces mécaniques diverses",
      "Qualité constante"
    ]
  },
  {
    id: "fer-rond-acier-etire",
    title: "Fer rond Acier étiré",
    image: "/assets/images/products/Fer rond Acier étiré.webp",
    specImage: null,
    description: "Acier calibré de précision pour pièces mécaniques",
    longDescription: "(Pas de description visible)",
    category: "aciers_speciaux",
    specifications: [
      "Aucune spécification technique fournie",
      "Grande précision dimensionnelle",
      "État de surface optimisé",
      "Disponible en diverses dimensions",
      "Applications industrielles diverses"
    ]
  }
];

export default aciersSpeciaux;
